<template>
  <div
    class="flex justify-center align-items-center gap-2"
    style="height: 100%; width: 100%; align-items: center"
  >
    <ButtonOpensModal
      label="Conversations"
      width="80vw"
      height="80vh"
      icon="pi-comments"
    >
      <Conversations></Conversations>
    </ButtonOpensModal>
    <ButtonOpensModal
      label="Examples"
      width="80vw"
      height="80vh"
      icon="pi-database"
    >
      <Examples></Examples>
    </ButtonOpensModal>
  </div>
</template>

<script setup lang="ts">
import {
  computed,
  ref,
  onMounted,
  onBeforeUnmount,
  watch,
  nextTick,
} from "vue";
import ButtonOpensModal from "@/src/shared-components/ButtonOpensModal.vue";
import { useStore } from "vuex";
import Conversations from "./conversations.vue";
import Examples from "./examples.vue";

const store = useStore();

const expandedRows = ref({});
const dialogOpen = ref(false);
</script>

<style scoped></style>
